"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const gatsby_1 = require("gatsby");
const logo = require('../images/counsel.png');
exports.default = () => (React.createElement("div", { id: 'header' },
    React.createElement(gatsby_1.Link, { to: '/' },
        React.createElement("img", { id: 'header__logo', src: logo })),
    React.createElement("h1", null, "counsel")));
//# sourceMappingURL=Heeder.js.map